import {
  isNullOrUndefined,
}                               from 'rewire-common';
import { Modal, IModalState }   from 'rewire-ui';
import {
  FieldFilter,
  _auditLogEntryTypeMap,
}                               from '../DataTypes';
import auditLogListModel, {
  IAuditLogFilters
}                               from './AuditLogListModel';
import auditLogItemViewModel, {
  IAuditLogDisabledColumnsMap
}                               from './AuditLogItemViewModel';

export interface IAuditLogDialogModelState extends IModalState {
}

export class AuditLogDialogModel extends Modal<IAuditLogDialogModelState> {
  static DEFAULT_TITLE = 'Audit Log';

  constructor() {
    super(AuditLogDialogModel.DEFAULT_TITLE);
    this.action('close');
  }

  reset() {
    auditLogListModel.reset();
    auditLogItemViewModel.reset();
  }

  async load(builtInFilters: IAuditLogFilters = {}, builtInEntityDataFilters: FieldFilter[] = [], disabledColumns: IAuditLogDisabledColumnsMap = {}) {
    this.reset();
    auditLogListModel.builtInFilters           = builtInFilters;
    auditLogListModel.builtInEntityDataFilters = builtInEntityDataFilters;
    auditLogItemViewModel.disabledColumns      = disabledColumns;
    const type = builtInFilters?.types?.[0];
    if (!isNullOrUndefined(type)) {
      this.state.title = `${_auditLogEntryTypeMap[type]} ${AuditLogDialogModel.DEFAULT_TITLE}`;
    } else {
      this.state.title = AuditLogDialogModel.DEFAULT_TITLE;
    }

    await auditLogListModel.load();
    await auditLogItemViewModel.load();
    auditLogListModel.selectFirst();
    this.open();
  }
}

const auditLogDialogModel = new AuditLogDialogModel();
export default auditLogDialogModel;
